import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function getFieldModifiers(field: SchemaField, needsSql: { value: boolean }): string {
  const modifiers: string[] = []

  if (field.primaryKey) {
    modifiers.push('.primaryKey()')
  }

  const isDateField = field.type === 'date' || field.type === 'timestamp'
  const hasValidDefault =
    field.default !== undefined && field.default !== null && !(isDateField && field.default === '')

  if (hasValidDefault) {
    if (field.type === 'select' && field.multiple) {
      const defaultValues = Array.isArray(field.default) ? field.default : [field.default]
      const jsonDefault = JSON.stringify(defaultValues.map((value) => String(value))).replaceAll(
        "'",
        "''"
      )
      modifiers.push(`.default(sql\`'${jsonDefault}'::jsonb\`)`)
      needsSql.value = true
    } else if (typeof field.default === 'string') {
      modifiers.push(`.default('${field.default}')`)
    } else {
      modifiers.push(`.default(${field.default})`)
    }
  }

  if (field.name === 'createdAt' || field.name === 'updatedAt') {
    modifiers.push('.default(sql`CURRENT_TIMESTAMP`)')
    needsSql.value = true
  }

  if (field.required || field.primaryKey) {
    modifiers.push('.notNull()')
  }

  return modifiers.join('')
}
